import { useCallback } from "react";
import { Link } from "react-router-dom";

// Constants
const ITEMS_TO_SHOW_COLLAPSED = 1;

// Component for rendering quick link groups
const QuickLinkGroup = ({ group, groupIndex, isExpanded, onToggle }) => {
  const shouldShowToggle = group.items.length > ITEMS_TO_SHOW_COLLAPSED;
  const displayItems = isExpanded
    ? group.items
    : group.items.slice(0, ITEMS_TO_SHOW_COLLAPSED);

  const handleToggle = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onToggle(groupIndex);
    },
    [groupIndex, onToggle]
  );

  return (
    <div className="card-primary link-group-compact-card">
      <div className="group-header">
        <h3 className="group-title">{group.group}</h3>
        {shouldShowToggle && (
          <button
            className="expand-toggle-btn"
            onClick={handleToggle}
            aria-label={isExpanded ? "Collapse" : "Expand"}
            type="button"
          >
            <i
              className={`fa fa-chevron-${
                isExpanded ? "up" : "down"
              } primary-color`}
            />
          </button>
        )}
      </div>

      <div className="group-links">
        {displayItems.map((link, index) => (
          <Link
            to={{
              pathname: link.path.includes("?")
                ? link.path.split("?")[0]
                : link.path,
              search: link.path.includes("?")
                ? link.path.split("?")[1]
                : undefined,
              state: link.state || {},
            }}
            className="quicklink-compact-item primary-color"
            key={`${groupIndex}-${index}`}
          >
            <div className="quicklink-content">
              <i className={`fa ${link.icon || "fa-external-link"}`}></i>
              <span className="quicklink-title">{link.title}</span>
              <i className="fa fa-chevron-right quicklink-arrow"></i>
            </div>
          </Link>
        ))}

        {shouldShowToggle && !isExpanded && (
          <button
            className="view-more-btn primary-color"
            onClick={handleToggle}
            type="button"
          >
            +{group.items.length - ITEMS_TO_SHOW_COLLAPSED} more
          </button>
        )}
      </div>
    </div>
  );
};

// Empty state
const EmptyQuickLinks = () => (
  <div className="card-primary no-links-message">
    <div className="no-links-icon">🔍</div>
    <h3>No quick links available</h3>
    <p>Your current permissions don't include access to any quick links.</p>
  </div>
);

// Main QuickLinks Component
const QuickLinks = ({ quickLinks, expandedGroups, onToggleGroup }) => {
  return (
    <div className="overview-quicklinks-section">
      <div className="section-header">
        <h2 className="color-dark">Quick Access Links</h2>
      </div>

      {quickLinks.length > 0 ? (
        <div className="quicklinks-compact-grid">
          {quickLinks?.map((group, groupIndex) => (
            <QuickLinkGroup
              key={groupIndex}
              group={group}
              groupIndex={groupIndex}
              isExpanded={Boolean(expandedGroups[groupIndex])}
              onToggle={onToggleGroup}
            />
          ))}
        </div>
      ) : (
        <EmptyQuickLinks />
      )}
    </div>
  );
};

export default QuickLinks;